export function forumCategoryMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      forumCategoryId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateForumCategoryId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixGetManyForumCategories(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      forumCategoryId: resource.objectId,
    })),
  };
}

export function fixCreateForumCategoryId(params, json) {
  return {
    data: {...json.result, id: json.result.objectId, forumCategoryId: json.result.objectId},
  };
}

export function forumCategoryMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, adminMarkets: json.result.markets.map((item) => ({markets : item}))},
  };
}